import axios from 'axios';
import {callAPI} from './Base';

class Services {

    submitForm(data, callback) {

        let fd = new FormData();

        for( let key in data) {
            if( key === 'metaData') {

                fd.append( 'meta_data', JSON.stringify(data[key]) );
                
            } else {
                fd.append( key, data[key]);
            }

        }

        axios({
            method: 'POST',
            url: callAPI('FormSubmit'),
            data: fd,
        }).then(function( response ) {
            callback( response )
        });
    }



}

let call = new Services();

export default call;


// WEBPACK FOOTER //
// ./src/Core/Services.js